import React, { useContext } from 'react';
import { FlowContext } from '../../core/flow-engine';
import Card from '../Card/Card';
import selectFundsIcon from '../../assets/images/select-funds-certified-icon.svg';

const SelectFundsCard = () => {
  const { next } = useContext(FlowContext);

  return (
    <Card
      icon={selectFundsIcon}
      title="Browse T. Rowe Price® Select Funds*"
      subtitle="We screen our actively managed mutual funds down to a simple list of diverse options, to help you select your investments more easily."
      buttonText="View T. Rowe Price® Select Funds"
      buttonFunction={next('taxableSelectFunds')}
      buttonID="btnTaxableSelectFunds"
    />
  );
};

export default SelectFundsCard;
